import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import * as DateFns from 'date-fns';
import { message } from 'antd';

import { useEventListener, useRouter } from './helpers/customHooks';
import NotFound from './components/Shared/NotFound';
import Login from './components/Login/Login';
import PrivateRoute from './components/Routes/PrivateRoute';
import PrivateAppRoutes from './components/Routes/PrivateAppRoutes';
import About from './components/About/About';
import ApiKeyModal from './components/Shared/ApiKeyModal/ApiKeyModal';
import {
  getAllSeasonWeeks,
  getPlayersSearchData,
  loadVenues, loadTeams, logoutUser,
  replaceUser,
  loadProfiles,
  getIntensities,
  getPeriodTypes
} from './store/actions';
import { requestData } from './config/services/datasets';
import { SERVER } from './config/server.config';
import Loader from './components/Shared/Loader';
import { fixLeague } from './helpers';
import {
  handleApiKeyOAuthCallback,
  isApiKeyOAuthCallbackPath
} from './helpers/apiKeyOAuth';
import { history } from './store/reducers';
import { CLEAN_ALL_STATE } from './store/types';

const App = ({
               user, // state
               loadUser, cleanState, loadInitialData, logoutUser, loadInitalMobile, loadIntensitiesPeriods// dispatch
             }) => {
  const [loading, setLoading] = useState(true);
  const { pathname, search } = useRouter();
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  const tokenUrl = new URLSearchParams(search).get('code');
  const [isExchangingApiKey, setIsExchangingApiKey] = useState(false);
  const [apiKey, setApiKey] = useState('');
  

  useEffect(() => {
    const exchangeApiKey = async () => {
      if (!tokenUrl || !isApiKeyOAuthCallbackPath(pathname)) {
        return;
      }

      setIsExchangingApiKey(true);

      try {
        const refreshToken = await handleApiKeyOAuthCallback({
          authorizationCode: tokenUrl,
          pathname,
          replaceRoute: history.replace
        });

        if (refreshToken) {
          setApiKey(refreshToken);
        } else {
          message.error({
            content: 'Unable to generate API Key',
            className: 'antd-message-alert'
          }, 10);
        }
      } finally {
        setIsExchangingApiKey(false);
      }
    };

    exchangeApiKey();
  }, [pathname, tokenUrl]);


  useEffect(() => {
    const action = async () => {
      const currentUser = JSON.parse(localStorage.getItem('user-token'));
      const nowDate = new Date();
      let isLogged = false;
      if (currentUser && currentUser.league) {
        await new Promise((resolve) => setTimeout(resolve, 1010));
        isLogged = !!(await requestData(SERVER.NEW_SCHEDULE_LIST(DateFns.subDays(nowDate, 1).getTime(), nowDate.getTime(), fixLeague(currentUser.league))));
        await new Promise((resolve) => setTimeout(resolve, 1010));
      }
      if (isLogged) {
        loadUser(currentUser);
      } else {
        localStorage.clear();
        await cleanState();
      }
      setLoading(false);
    };
    action();
  }, []);
  useEffect(() => {
    if (user.isLogged) {
      localStorage.setItem('user-token', JSON.stringify(user, null));
      localStorage.removeItem('profiles');
      if(!isMobile){
        loadInitialData();
      }else{
        loadInitalMobile(true);
      }
      // Practice creation needs these options on both desktop and mobile
      loadIntensitiesPeriods(user.teamId);
    }
  }, [user.email]);
  const reload = () => {
    if (!loading) {
      const currentUser = localStorage.getItem('user-token');
      if (currentUser) {
        if (user.email !== JSON.parse(currentUser).email) {
          cleanState();
          localStorage.removeItem('store');
          loadUser(JSON.parse(currentUser));
          history.push('/');
        }
      } else {
        if (user.isLogged) {
          localStorage.removeItem('store');
          logoutUser();
          cleanState();
        }
      }
    }
  };
  useEventListener('visibilitychange', reload);

  return (
    <span onMouseEnter={reload} onMouseLeave={reload}>
      {loading || isExchangingApiKey ? <Loader forceLoader={true} style={{ height: '100vh' }} />
        :
        (
          <Switch>
            <Route path={`/404`} component={NotFound} />
            <Route path={`/login`} component={Login} />
            <Route path={`/about`} component={About} />
            <PrivateRoute component={PrivateAppRoutes} />
          </Switch>
        )
      }
      <div className="version-tag">{process.env.REACT_APP_VERSION}</div>
      <ApiKeyModal
        apiKey={apiKey}
        user={user}
        show={!!apiKey && user.email}
        onHide={() => setApiKey("")}
      />
  </span>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadUser(user) {
      dispatch(replaceUser(user));
    },
    logoutUser() {
      dispatch(logoutUser());
    },
    cleanState() {
      dispatch({ type: CLEAN_ALL_STATE });
    },
    loadInitalMobile(isMobile){
      dispatch(loadTeams());
      dispatch(loadVenues(isMobile));
      dispatch(loadProfiles(isMobile));
    },
    loadInitialData() {
      dispatch(loadTeams());
      dispatch(loadProfiles());
      dispatch(getPlayersSearchData());
      dispatch(loadVenues());
      dispatch(getAllSeasonWeeks());
    },
    loadIntensitiesPeriods(teamId){
      dispatch(getIntensities(teamId));
      dispatch(getPeriodTypes(teamId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));


// loadProfiles(){
//   leer localStorage;
//   if (hay profiles && dateFns.isToday(timestamp))
//     cargar a redux los profiles
//   else
//     fetch profiles
//     cargar a redux
//     guardar a localStorage con timestamp
// }
